import axios from 'axios';
import SignifydFingerprintService from '@/services/signifydFingerprint.service';
import WebCartUser from '@/models/entities/user/webCartUser';
import SocialProvider from '@/models/entities/social-provider';

const getUserTokenData = async () => {
  const claims = await axios.get('api/me/claims');

  if (claims?.data?.data) {
    return claims.data.data;
  }

  return null;
};

const state = {
  user: {} as WebCartUser,
  verificationLocked: false,
  federatedLoginAttempted: null as SocialProvider | null,
};

const getters = {
  isCustomer(state) {
    return Boolean(state.user?.sub);
  },
  isEmployee(state) {
    return Boolean(state.user?.emp);
  },
  isCustomerModeScan(state, _, rootState) {
    return Boolean(state.user?.sub && state.user?.scango && rootState.config.scanAndGoEnabled);
  },
  isGuest(state) {
    return (state.user && !state.user.sub) || !state.user;
  },
  isSignifydEnabled(_, rootState) {
    return Boolean(rootState.config.signifydKey);
  },
  getUser(state) {
    return state.user;
  },
  getCustomer(state) {
    return state.user ? state.user.sub : null;
  },
  getEmployee(state) {
    return state.user ? state.user.emp : null;
  },
  getAccountId(state) {
    return state.user.num ?? null;
  },
  getCustomerPowerField(state) {
    return state.user.pf ?? null;
  },
  isVerificationLocked(state) {
    return state.verificationLocked;
  },
  getFederatedLoginAttempted(state) {
    return state.federatedLoginAttempted;
  },
};

export const SET_USER = 'SET_USER';
export const SET_ACCOUNT_ID = 'SET_ACCOUNT_ID';
export const SET_VERIFICATION_LOCKED = 'SET_VERIFICATION_LOCKED';
export const SET_FEDERATED_LOGIN_ATTEMPTED = 'SET_FEDERATED_LOGIN_ATTEMPTED';

const mutations = {
  [SET_USER](state, user) {
    state.user = user;
  },
  [SET_VERIFICATION_LOCKED](state, verificationLocked) {
    console.debug(`SET_VERIFICATION_LOCKED ${verificationLocked}`);
    state.verificationLocked = verificationLocked;
  },
  [SET_FEDERATED_LOGIN_ATTEMPTED](state, federatedLoginAttempted: SocialProvider | null) {
    state.federatedLoginAttempted = federatedLoginAttempted;
  },
};

const actions = {
  async setUserFromCookie({ commit, rootState }) {
    try {
      const user = await getUserTokenData();
      commit(SET_USER, user);
      const sessionId = user.cart + user.jti + user.fi;
      SignifydFingerprintService.load(rootState, sessionId);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
